module.exports={
	"globalCoverageEffectiveDate": "",
	"subscriber": {
		"hireDate": "",
		"birthDate": "",
		"gender": "",
		"relationshipCode": "20",
		"ssn": "",
		"fullName": {
			"first": "",
			"last": ""
		},
		"address": {
			"address1": "",
			"state": "",
			"city": "",
			"zipCode": {
				"base": ""
			}
		},
		"phones": {},
		"memberCoverages": [],
		"medicareEligibleIndicator": "unknown",
		"otherInsuranceIndicator": "unknown",
		"otherInsurance": {}
	},
	"dependents": []
}
